import { Component, Inject } from '@angular/core';
import {
  AppearanceAnimation,
  ButtonLayoutDisplay,
  ButtonMaker,
  DialogBelonging,
  DialogInitializer,
  DialogLayoutDisplay,
  DisappearanceAnimation,
} from '@costlydeveloper/ngx-awesome-popup';
import { faCoins, faCreditCard, } from '@fortawesome/pro-light-svg-icons';
import { faX } from '@fortawesome/pro-regular-svg-icons';
import { DialogPayComponent } from '../dialog-pay/dialog-pay.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dialog-select-payment',
  templateUrl: './dialog-select-payment.component.html',
  styleUrls: ['./dialog-select-payment.component.scss'],
})
export class DialogSelectPaymentComponent {
  private subscriptions: Subscription = new Subscription();
  faCoins = faCoins;
  faCreditCard = faCreditCard;
  faX = faX;

  constructor(
    @Inject('dialogBelonging') public dialogBelonging: DialogBelonging
  ) { }

  ngOnInit() {
    this.subscriptions.add(
      // IDialogEventsController
      this.dialogBelonging.eventsController.onButtonClick$.subscribe(
        (_Button) => {
          if (_Button.ID === 'submit') {
            this.dialogBelonging.eventsController.close();
          }
        }
      )
    );
  }

  goToPaymentMethod(payment_method: string) {
    const dialogPopup = new DialogInitializer(DialogPayComponent);
    dialogPopup.setCustomData({ payment_method: payment_method });

    dialogPopup.setConfig({
      width: '500px',
      layoutType: DialogLayoutDisplay.NONE,
      animationIn: AppearanceAnimation.NONE,
      animationOut: DisappearanceAnimation.NONE,
      escapeKeyClose: true,
    });

    dialogPopup.setButtons([
      new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
      new ButtonMaker('Pagar', 'submit', ButtonLayoutDisplay.SUCCESS),
    ]);
    dialogPopup.openDialog$().subscribe((resp) => {
      this.dialogBelonging.eventsController.close();
    });
  }
  close() {
    this.dialogBelonging.eventsController.close();
  }
}
